import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Field,
  reduxForm,
  FieldArray,
} from 'redux-form';
import {
  Card,
  CardBody,
  Col,
  Row,
  FormGroup,
  Badge,
} from 'reactstrap';
import renderSelectField from '../../../../shared/components/form/Select';
import TextBox from '../../../../shared/components/form/TextBox';
import setPropsAsInitialValues from '../../../../helpers/setPropsAsInitialValues';
import validate from './validate';
import StudentsScoresTable from './StudentsScoresTable';
import {
  dateFormat,
  dateTimeFormat,
} from '../../../../helpers/dateFormat';

class HomeworkForm extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
    handleChangeText: PropTypes.func.isRequired,
    handleSort: PropTypes.func.isRequired,
    handleFilterChangeText: PropTypes.func.isRequired,
    onChangeSelect: PropTypes.func.isRequired,

    showSpinner: PropTypes.func.isRequired,

    submitting: PropTypes.bool,
    loading: PropTypes.bool.isRequired,
    tareaMateriaAlumnos: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    puntajeTotal: PropTypes.number.isRequired,
    descripcion: PropTypes.string.isRequired,
    tipoTarea: PropTypes.shape({}),
    tiposTareas: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    canEdit: PropTypes.bool,
    filterValue: PropTypes.string,
    sortColumn: PropTypes.string.isRequired,
    sortType: PropTypes.string.isRequired,
    utilizaPorcentajePesoMateria: PropTypes.bool.isRequired,
    finCalificarTareas: PropTypes.string.isRequired,
  }

  static defaultProps = {
    submitting: false,
    canEdit: true,
    filterValue: '',
    tipoTarea: { value: 0, label: '-' },
  }

  constructor(props) {
    super(props);
    this.state = {};
  }

  format = (date = '') => {
    if (date) {
      return dateFormat(date.split('T')[0]);
    }

    return '';
  };

  render() {
    const {
      loading,
      showSpinner,
    } = this.props;

    if (loading) {
      return showSpinner();
    }

    const {
      handleSubmit,
      handleChangeText,
      handleSort,
      handleFilterChangeText,
      onChangeSelect,
      submitting,
      onBack,
      puntajeTotal,
      tiposTareas = [],
      descripcion = '',
      tipoTarea,
      canEdit,
      tareaMateriaAlumnos,
      filterValue,
      utilizaPorcentajePesoMateria,
      finCalificarTareas,
      sortColumn,
      sortType,
    } = this.props;

    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <div className="card__title" style={{ marginTop: '10px' }}>
              {canEdit ? (
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={submitting}
                  onClick={handleSubmit}
                >Guardar
                </button>
              ) : null
              }
              <button
                type="submit"
                className="btn btn-outline-secondary"
                onClick={onBack}
              >Cancelar - Volver
              </button>
            </div>
            <Form inline className="form" onSubmit={handleSubmit}>
              <Col md={canEdit ? 12 : 2} lx={12}>
                <div className="card__title">
                  <h5 className="bold-text">Datos de la tarea</h5>
                </div>
              </Col>
              {!canEdit && finCalificarTareas ? (
                <Col md={10} lx={12}>
                  <div className="card__title">
                    <h4>
                      <Badge color="warning">
                        Fecha L&iacute;mite Calificar Tareas {dateTimeFormat(finCalificarTareas)}
                      </Badge>
                    </h4>
                  </div>
                </Col>
              ) : null
              }
              <Col lg={3} md={4} sm={6} lx={12}>
                <div className="form__form-group">
                  <span className="form__form-group-label required">Tarea</span>
                  <div className="form__form-group-field">
                    <Field
                      name="descripcion"
                      component={TextBox}
                      placeholder="Tarea"
                      autoComplete="false"
                      multiple
                      type="text"
                      maxLength="256"
                      disabled={!canEdit}
                      defaultValue={descripcion}
                      onBlur={({ target }) => handleChangeText({ target })}
                    />
                  </div>
                </div>
              </Col>
              <Col lg={3} md={4} sm={6} lx={12}>
                <div className="form__form-group">
                  <span className="form__form-group-label required">Tipo Tarea</span>
                  <div className="form__form-group-field">
                    <Field
                      name="tipoTarea"
                      placeholder="Tipo Tarea"
                      onChange={
                        props => onChangeSelect({ option: props, name: 'tipoTarea' })
                      }
                      options={tiposTareas}
                      component={renderSelectField}
                    />
                  </div>
                </div>
              </Col>
              <Col lg={3} md={4} sm={6} lx={12}>
                <div className="form__form-group">
                  <span className="form__form-group-label required">Puntaje Total</span>
                  <div className="form__form-group-field">
                    <Field
                      name="puntajeTotal"
                      component={TextBox}
                      min="0"
                      max={tipoTarea.value === 2 ? 1 : 5000}
                      placeholder="Puntaje Total"
                      autoComplete="false"
                      type="number"
                      disabled={!canEdit || tipoTarea.value === 2}
                      parse={val => Number(val)}
                      onBlur={({ target }) => handleChangeText({ target })}
                    />
                  </div>
                </div>
              </Col>

              {tipoTarea.value !== 2 ? (
                <Col lg={3} md={4} sm={6} lx={12}>
                  <div className="form__form-group">
                    <span className="form__form-group-label required">Porcentaje Peso Materia</span>
                    <div className="form__form-group-field">
                      <Field
                        name="porcentajePesoMateria"
                        component={TextBox}
                        min="0"
                        max="100"
                        placeholder={
                          utilizaPorcentajePesoMateria && tipoTarea.value !== 2
                            ? 'Porcentaje Peso Materia'
                            : 'Materia Sin Peso'
                        }
                        autoComplete="false"
                        type="number"
                        disabled={tipoTarea.value === 2 || (!utilizaPorcentajePesoMateria || !canEdit)}
                        format={value => (utilizaPorcentajePesoMateria ? value : '')}
                        parse={val => Number(val)}
                        onBlur={({ target }) => handleChangeText({ target })}
                      />
                    </div>
                  </div>
                </Col>
              ) : null
              }

              <Col lg={3} md={4} sm={6} lx={12}>
                <div className="form__form-group">
                  <span className="form__form-group-label required">Fecha Entrega</span>
                  <div className="form__form-group-field">
                    <Field
                      name="fechaEntrega"
                      component={TextBox}
                      placeholder="Fecha Entrega"
                      autoComplete="false"
                      type={canEdit ? 'date' : 'text'}
                      disabled={!canEdit}
                      format={value => (canEdit ? value : this.format(value))}
                      onBlur={({ target }) => handleChangeText({ target })}
                    />
                  </div>
                </div>
              </Col>
            </Form>
          </CardBody>
        </Card>
        <Card>
          <CardBody>
            <Row>
              <Col>
                <FormGroup row className="form">
                  <Col lg={3} md={4} sm={6} lx={12}>
                    <div className="form__form-group">
                      <span className="form__form-group-label">Filtrar alumnos:</span>
                      <div className="form__form-group-field">
                        <Field
                          name="filterValue"
                          component={TextBox}
                          placeholder="Texto a buscar"
                          autoComplete="false"
                          type="text"
                          onChange={handleFilterChangeText}
                          maxLength={32}
                          defaultValue={filterValue}
                        />
                      </div>
                    </div>
                  </Col>
                </FormGroup>
              </Col>
            </Row>

            <FieldArray
              key="tareaMateriaAlumnos"
              name="tareaMateriaAlumnos"
              component={StudentsScoresTable}
              items={tareaMateriaAlumnos}
              puntajeTotal={puntajeTotal}
              editScore={!canEdit}
              sortColumn={sortColumn}
              sortType={sortType}
              onChangeText={handleChangeText}
              onSort={handleSort}
            />

            <div className="card__title" style={{ marginTop: '10px' }}>
              {canEdit ? (
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={submitting}
                  onClick={handleSubmit}
                >Guardar
                </button>
              ) : null
              }
              <button
                type="submit"
                className="btn btn-outline-secondary"
                onClick={onBack}
              >Cancelar - Volver
              </button>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

const ReduxHomeworkForm = reduxForm({
  form: 'HomeworkForm',
  validate,
  enableReinitialize: true,
})(HomeworkForm);

export default setPropsAsInitialValues(ReduxHomeworkForm);
